<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import 'src/css/index.scss';

body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue